import { fetcher } from '@shared/fetcher';
import { ILocation, LocationSchema } from '@shared/types.ts';

export async function fetchCities(url: string) {
  const res = await fetcher.get<{ data: ILocation[] }>(url).catch(() => null);
  if (!res?.data) return undefined;
  return res?.data.data.filter((i) => LocationSchema.isValidSync(i));
}
